import {AGEYTOMESH_TAG_ID} from "../../shared/constants/misc";
import {LimitedLink, StatusPseudoTag} from "../../shared/pages/project/project";
import {CreateLinkTo} from "../../shared/constants/linkTo";
import {BTag} from "../../core/components";
import {bTag} from "../../core";
import {FC, useRef, useState} from "react";
import { COMPETITION_STATUSES, getCompetitionStatus } from "_competition/helpers/getCompetitionStatus";
import { useShowRatingCompetitionTag } from "_competition/helpers/useShowRatingCompetitionTag";
import { useTranslation } from "react-i18next";
import { Tag } from "@brg/api";
import {BTagsGridNew} from "../../core/components/bTag/bTagsGridNew/bTagsGridNew";

export const CompetitionTagLine: FC<{competitionProps: any, currentTagId?: string, notClickableTags?: boolean }> = ({competitionProps, currentTagId, notClickableTags }) => {
    const listRef = useRef<HTMLDivElement>(null);
    const [_, setScrollLeft] = useState(0);
    const competitionStatus = getCompetitionStatus(competitionProps);
    const { t } = useTranslation()
    const isByCategory = !!competitionProps?.isByCategory;

    const getTagRoute = (v: Tag) => {
        return CreateLinkTo.tag(v.tagId)
    }

    const getCategoryColorTheme = (tag: any) => {
        if (!isByCategory || !tag?.isTagCategory) return undefined;
        const whiteOnly = !!tag?.hasEduTags && !tag?.hasCommonTags;
        const bg = whiteOnly ? '#102D69' : 'rgba(16, 45, 105, 0.50)';
        return {
            fill: { default: bg, hover: bg, disabled: bg },
            text: { default: '#FFF', hover: '#FFF', disabled: '#FFF' },
        };
    }

    const showStatusTag = competitionStatus === COMPETITION_STATUSES.full_finish
        || competitionStatus === COMPETITION_STATUSES.apply_finish;
    const isSpecial = useShowRatingCompetitionTag(competitionProps);

    const preventTagClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const statusTag = showStatusTag ? (
        <StatusPseudoTag onClick={preventTagClick}>
            {t(competitionStatus === COMPETITION_STATUSES.full_finish
                ? 'competition.statuses.Competition_ended'
                : 'competition.statuses.Competition_apply_ended')}
        </StatusPseudoTag>
    ) : null;

    const specialRatingTag = isSpecial ? (
        <StatusPseudoTag backgroundColor="#29894E" onClick={preventTagClick}>
            {t('competition.statuses.rating_competition')}
        </StatusPseudoTag>
    ) : null;

    const requiredTags = competitionProps?.requredTags ?? [];
    const regularTags = competitionProps?.regularTags ?? [];

    return <div style={{position: 'relative'}}>
        <BTagsGridNew scrollMode="all" ref={listRef} onScroll={e => setScrollLeft(listRef?.current?.scrollLeft || 0)}>
            {showStatusTag ? statusTag : specialRatingTag}
            {showStatusTag && specialRatingTag}
            {[ ...requiredTags, ...regularTags ].map((v) => {
                const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                const colorTheme = getCategoryColorTheme(v);

                if (notClickableTags) {
                    return (
                        <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag isCompetitionsTitleTag isCompetitionsStyleTag colorTheme={colorTheme}>
                            {bTag.title(v)}
                        </BTag>
                    )
                }
                return (
                    <LimitedLink style={{...(currentTagId && v.tagId === currentTagId && { pointerEvents: 'none'})}} key={v.tagId} to={getTagRoute(v)} target={target}>
                        <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag isCompetitionsTitleTag isCompetitionsStyleTag colorTheme={colorTheme}>
                            {bTag.title(v)}
                        </BTag>
                    </LimitedLink>
                )
            })}
        </BTagsGridNew>
    </div>
}import {AGEYTOMESH_TAG_ID} from "../../shared/constants/misc";
import {LimitedLink, StatusPseudoTag} from "../../shared/pages/project/project";
import {CreateLinkTo} from "../../shared/constants/linkTo";
import {BTag} from "../../core/components";
import {bTag} from "../../core";
import {FC, useRef, useState} from "react";
import { COMPETITION_STATUSES, getCompetitionStatus } from "_competition/helpers/getCompetitionStatus";
import { useShowRatingCompetitionTag } from "_competition/helpers/useShowRatingCompetitionTag";
import { useTranslation } from "react-i18next";
import { Tag } from "@brg/api";
import {BTagsGridNew} from "../../core/components/bTag/bTagsGridNew/bTagsGridNew";

export const CompetitionTagLine: FC<{competitionProps: any, currentTagId?: string, notClickableTags?: boolean }> = ({competitionProps, currentTagId, notClickableTags }) => {
    const listRef = useRef<HTMLDivElement>(null);
    const [_, setScrollLeft] = useState(0);
    const competitionStatus = getCompetitionStatus(competitionProps);
    const { t } = useTranslation()
    const isByCategory = !!competitionProps?.isByCategory;

    const getTagRoute = (v: Tag) => {
        return CreateLinkTo.tag(v.tagId)
    }

    const getCategoryColorTheme = (tag: any) => {
        if (!isByCategory || !tag?.isTagCategory) return undefined;
        const whiteOnly = !!tag?.hasEduTags && !tag?.hasCommonTags;
        const bg = whiteOnly ? '#102D69' : 'rgba(16, 45, 105, 0.50)';
        return {
            fill: { default: bg, hover: bg, disabled: bg },
            text: { default: '#FFF', hover: '#FFF', disabled: '#FFF' },
        };
    }

    const showStatusTag = competitionStatus === COMPETITION_STATUSES.full_finish
        || competitionStatus === COMPETITION_STATUSES.apply_finish;
    const isSpecial = useShowRatingCompetitionTag(competitionProps);

    const preventTagClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const statusTag = showStatusTag ? (
        <StatusPseudoTag onClick={preventTagClick}>
            {t(competitionStatus === COMPETITION_STATUSES.full_finish
                ? 'competition.statuses.Competition_ended'
                : 'competition.statuses.Competition_apply_ended')}
        </StatusPseudoTag>
    ) : null;

    const specialRatingTag = isSpecial ? (
        <StatusPseudoTag backgroundColor="#29894E" onClick={preventTagClick}>
            {t('competition.statuses.rating_competition')}
        </StatusPseudoTag>
    ) : null;

    const requiredTags = competitionProps?.requredTags ?? [];
    const regularTags = competitionProps?.regularTags ?? [];

    return <div style={{position: 'relative'}}>
        <BTagsGridNew scrollMode="all" ref={listRef} onScroll={e => setScrollLeft(listRef?.current?.scrollLeft || 0)}>
            {showStatusTag ? statusTag : specialRatingTag}
            {showStatusTag && specialRatingTag}
            {[ ...requiredTags, ...regularTags ].map((v) => {
                const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';
                const colorTheme = getCategoryColorTheme(v);

                if (notClickableTags) {
                    return (
                        <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag isCompetitionsTitleTag isCompetitionsStyleTag colorTheme={colorTheme}>
                            {bTag.title(v)}
                        </BTag>
                    )
                }
                return (
                    <LimitedLink style={{...(currentTagId && v.tagId === currentTagId && { pointerEvents: 'none'})}} key={v.tagId} to={getTagRoute(v)} target={target}>
                        <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag isCompetitionsTitleTag isCompetitionsStyleTag colorTheme={colorTheme}>
                            {bTag.title(v)}
                        </BTag>
                    </LimitedLink>
                )
            })}
        </BTagsGridNew>
    </div>
}